import React, { Component } from "react";
import givBeeLogo from "./assets/img/givbeeLogo.png";
import { NavLink } from "react-router-dom";
import { withRouter } from "../../../withRouter";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import "./Header.css";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { menuList: false };
  }
  menuListToggle = () => {
    this.setState({
      menuList: !this.state.menuList,
      activeElement: "",
    });
  };

  openMenu() {
    this.setState({
      menuList: true,
    });
  }
  navigateToLink(linkToNavigate) {
    this.setState({
      activeElement: linkToNavigate,
    });
    this.props.navigate(linkToNavigate);
  }
  openLoginTab = () => {
    const win = window.open("/signin", "_blank");
    win.focus();
  };
  handleClose = (e) => {
    e.stopPropagation(); // <-- prevent further bubbling of click event
    this.setState({
      menuList: false,
    });
  };
  render() {
    return (
      <>
        <header id="header" className="fixed-top d-flex align-items-center">
          <div className="container d-flex align-items-center justify-content-between">
            <div className="logo">
              <img
                src={givBeeLogo}
                alt=""
                style={{ width: "auto", height: "70px" }}
              />
            </div>
            <nav id="navbar" className="navbar">
              <ul>
                <li className="dropdown">
                  <NavLink
                    to="/"
                    style={{ padding: "0.5rem 1.25rem 0.2rem 1.25rem" }}
                  >
                    <span style={{ fontSize: "16px" }}>Solutions</span>{" "}
                    <i className="bi bi-chevron-down" />
                  </NavLink>
                  <ul id="dropDownList">
                    <li style={{ borderBottom: "1px solid #D7DBDD" }}>
                      <NavLink to="/nonprofits" style={{ fontSize: "16px" }}>
                        For Nonprofits & Small Businesses
                      </NavLink>
                    </li>

                    <li
                      style={{
                        borderBottom: "1px solid #D7DBDD",
                      }}
                    >
                      <NavLink
                        to="/eventtext"
                        style={{
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                      >
                        EVENTtext
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/restaurant-and-food-truck-texting"
                        style={{ fontSize: "16px" }}
                      >
                        For Restaurants & Food Trucks
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink
                    className="nav-link scrollto"
                    to="/signin"
                    style={{ fontSize: "16px" }}
                  >
                    Sign In
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="nav-link scrollto"
                    to="/signup"
                    style={{ fontSize: "16px" }}
                  >
                    Sign Up
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    className="nav-link scrollto"
                    to="/blog"
                    style={{ fontSize: "16px" }}
                  >
                    Blog
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    className="nav-link scrollto "
                    to="/contactus"
                    style={{ fontSize: "16px" }}
                  >
                    Contact
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="nav-link scrollto"
                    to="/faqs"
                    style={{ fontSize: "16px" }}
                  >
                    FAQs
                  </NavLink>
                </li>
              </ul>
              <i
                className="bi bi-list mobile-nav-toggle"
                onClick={(e) => this.openMenu()}
              />
            </nav>
            {/* .navbar */}
          </div>
        </header>
        <Modal
          isOpen={this.state.menuList}
          toggle={this.menuListToggle}
          size="sm"
        >
          <Row>
            <Col md={12}>
              <CloseIcon
                onClick={(e) => this.menuListToggle()}
                style={{ float: "right", margin: "0.5em 1em 0em 0em" }}
              />
            </Col>
          </Row>
          <ModalBody style={{ padding: "0.5em" }}>
            <nav className="mobileViewNav">
              <ul style={{ listStyle: "none", paddingLeft: "0em" }}>
                <li>
                  <span>
                    <NavLink
                      to="/"
                      onClick={this.handleClose}
                      style={({ isActive }) => ({
                        color: isActive ? "#DC7633" : "#000",
                        fontWeight: isActive ? "bold" : "500",
                      })}
                    >
                      Solutions
                    </NavLink>
                  </span>
                </li>

                <li>
                  <a
                    onClick={() => this.openLoginTab()}
                    target="_blank"
                    style={{ color: "#000", fontWeight: "500" }}
                  >
                    Sign In
                  </a>
                </li>
                <li>
                  <NavLink
                    to="/signup"
                    onClick={this.handleClose}
                    style={({ isActive }) => ({
                      color: isActive ? "#DC7633" : "#000",
                      fontWeight: isActive ? "bold" : "500",
                    })}
                  >
                    Sign Up
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/blog"
                    onClick={this.handleClose}
                    style={({ isActive }) => ({
                      color: isActive ? "#DC7633" : "#000",
                      fontWeight: isActive ? "bold" : "500",
                    })}
                  >
                    Blog
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/contactus"
                    onClick={this.handleClose}
                    style={({ isActive }) => ({
                      color: isActive ? "#DC7633" : "#000",
                      fontWeight: isActive ? "bold" : "500",
                    })}
                  >
                    Contact
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/faqs"
                    onClick={this.handleClose}
                    style={({ isActive }) => ({
                      color: isActive ? "#DC7633" : "#000",
                      fontWeight: isActive ? "bold" : "500",
                    })}
                  >
                    FAQs
                  </NavLink>
                </li>
              </ul>
            </nav>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default withRouter(Header);
